class LoggingServiceBase {
    constructor() {
        Object.defineProperty(this, "mode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const mode = process.env.FUSE_DYNAMO_COUCH_DEBUG_MODE;
        if (mode === "true") {
            this.mode = true;
        }
        else {
            this.mode = false;
        }
    }
    log(message, ...optionalParams) {
        try {
            if (this.mode) {
                console.log(message, optionalParams);
            }
        }
        catch (error) {
        }
    }
}
export const LoggingService = new LoggingServiceBase();
